  import React, { useEffect, useState } from 'react';
  import axios from 'axios';
  import Logo from "../../assets/gdg-sharp.svg";
  import "./nav.css";
  import { MoonLoader } from 'react-spinners';
  import LaunchIcon from '@mui/icons-material/Launch';
  import InstagramIcon from '@mui/icons-material/Instagram';
  import WhatsAppIcon from '@mui/icons-material/WhatsApp';
  import LinkedInIcon from '@mui/icons-material/LinkedIn';
  import confetti from "canvas-confetti";
  import { Link } from 'react-router-dom';

  const Nav = () => {
    const [data, setData] = useState({
      time: "",
      arcade: 0,
      enrolled: 0,
      completed: 0,
      both: 0,
    });

    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const fetchData = async () => {
        setLoading(true);
        try {
          const response = await axios.get(
            "https://script.google.com/macros/s/AKfycbwvARJMmp-kXdGLf8gImwWEKhn2oAwBqZR0EufhD_4nFNNd6JHN3hIj6LNCctIjnyiR/exec"
          );
          setData(response.data);
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchData();
    }, []);

    // Function to trigger confetti at random positions
    const handleCelebrate = () => {
      for (let i = 0; i < 5; i++) {
        confetti({
          particleCount: 150,
          angle: Math.random() * 360,
          spread: 40,
          startVelocity: 40,
          origin: {
            x: Math.random(), // Random horizontal position
            y: Math.random(), // Random vertical position
          },
        });
      }
    };

    return (
      <>
        <div className="nav_container">
          <div className="logo">
          <Link to="/">  <img src={Logo} alt="Google Developer Groups" /> </Link>
          </div>

          <div className="nav_links">
            <a
              title="Official Community"
              href="https://gdg.community.dev/gdg-on-campus-poornima-university-jaipur-india/"
              target="main"
            >
              <LaunchIcon />
            </a>
            <a
              title="Follow Instagram"
              target="main"
              href="https://instagram.com/gdg.poornima"
            >
              <InstagramIcon />
            </a>
            <a
              title="Follow LinkedIn"
              target="main"
              href="https://in.linkedin.com/company/gdg-poornima"
            >
              <LinkedInIcon />
            </a>
            <a
              title="Join Whatsapp"
              target="main"
              href="https://chat.whatsapp.com/BUzm2aq56HJHVmyiuzGIpJ"
            >
              <WhatsAppIcon />
            </a>
          </div>
        </div>

        <div className="links_container">
       <Link to="/"> <div className="link_content"><Link to="/">Home</Link></div></Link>

          <div className="link_content"><Link to="/genai-result">GenAI Study Jams Result 2024-25</Link></div>

          <div className="link_content"><Link to="/certify">Certificate Authenticator</Link></div>
        </div>
        
      </>
    );
  };

  export default Nav;
